import React, { useState, useRef, useEffect, useContext } from 'react';
import axios from 'axios';
import { useLocation  } from 'react-router-dom';
import $ from 'jquery';
import { MyContext } from './MyContextProvider'; // Import your context
import { useParams,useNavigate  } from 'react-router-dom';
import { useTranslation } from "react-i18next";
import JsBarcode from 'jsbarcode';
import QRCode from "qrcode";
import './Organization_Profile.css';

const Organization_Profile = (props) => {
  const didFetchRef = useRef(false);
  const initRef = useRef({ headerHandled: false, dataTableHandled: false });

  const { i18n } = useTranslation();
  const { t } = useTranslation();
  var location = useLocation();
  const { App_Data, setApp_Data } = useContext(MyContext); // Access the context
  const urlParams = new URLSearchParams(window.location.search);
  //setReturn_Path(urlParams.get('Return'));
  const navigate = useNavigate();

  const inputFontStyle = {
    fontFamily: 'sans-serif',
    fontSize: '16px',
    fontWeight: 'normal',
    fontStyle: 'normal',
    color: '#000'
  };


  const [newData, setNewData] = useState({
 	Source_Path:"ORGANIZATION_PROFILE",
    Status: App_Data.Status,
    Parameter: App_Data.Parameter,
    Search: App_Data.Search,
    Return_Path: App_Data.Return_Path,
    Return_ID: App_Data.ID,
    Return_Status: App_Data.Return_Status,
	Object_Text:";",
	ORGANIZATION_PROFILE:-1
  });


  const [ORGANIZATION_PROFILE, setORGANIZATION_PROFILE] = React.useState(null);
  const [ORGANIZATION_PROFILE_D, setORGANIZATION_PROFILE_D] = React.useState(null);



 
  useEffect(() => {
    document.title = "SRWAE | "+t('Organization Profile');  
	  
 
	if(location.hash=="#Return"){
		setNewData({ ...newData});
		setApp_Data({ ...newData})
		navigate('/Organization_Profile',{replace:true});
	}
	if(location.hash=="#New"){
		const collectClientInfo = () => {
		return {
			userAgent: navigator.userAgent,
			language: navigator.language,
			platform: navigator.platform,
			screenResolution: `${screen.width}x${screen.height}`,
			colorDepth: screen.colorDepth,
			timezoneOffset: new Date().getTimezoneOffset(),
			timezone: Intl.DateTimeFormat().resolvedOptions().timeZone,
			cookieEnabled: navigator.cookieEnabled,
			javaEnabled: navigator.javaEnabled(),
			online: navigator.onLine,
			referrer: document.referrer,
			locationHref: window.location.href,
			screenOrientation: screen.orientation?.type || 'unknown'
		  };
		};

		const clientInfo = collectClientInfo();
		handleLoadNewORGANIZATION_PROFILE(clientInfo,"OpenNew");

		navigate('/Organization_Profile',{replace:true});
	}
	if(location.hash=="#Search"){
		setNewData({ ...newData});
		setApp_Data({ ...newData});
		navigate('/Organization_Profile_S',{replace:true});
	}
	if(location.hash=="#Update"){
		var Temp_Data2 =  JSON.parse(JSON.stringify(ORGANIZATION_PROFILE));
		if(Temp_Data2.status!="New"){
			Temp_Data2.status = "UpToDate";
			handlePutORGANIZATION_PROFILE(Temp_Data2);
		}else{
			Temp_Data2.status = "UpToDate";
			handlePostORGANIZATION_PROFILE(Temp_Data2);
			const collectClientInfo = () => {
			  return {
				userAgent: navigator.userAgent,
				language: navigator.language,
				platform: navigator.platform,
				screenResolution: `${screen.width}x${screen.height}`,
				colorDepth: screen.colorDepth,
				timezoneOffset: new Date().getTimezoneOffset(),
				timezone: Intl.DateTimeFormat().resolvedOptions().timeZone,
				cookieEnabled: navigator.cookieEnabled,
				javaEnabled: navigator.javaEnabled(),
				online: navigator.onLine,
				referrer: document.referrer,
				locationHref: window.location.href,
				screenOrientation: screen.orientation?.type || 'unknown'
			  };
			};

			const clientInfo = collectClientInfo();
			handleLoadNewORGANIZATION_PROFILE(clientInfo,"OpenNew");
		}
		navigate('/Organization_Profile',{replace:true});
	}
	if(location.hash=="#FormPreview"){
		setNewData({ ...newData});
		setApp_Data({ ...newData});
		navigate('/Organization_Profile_P',{replace:true});
	}
	if(location.hash=="#SearchPreview"){
		setNewData({ ...newData});
		setApp_Data({ ...newData});
		navigate('/Organization_Profile_S_P',{replace:true});
	}
	if(location.hash=="#Print"){
		setNewData({ ...newData});
		setApp_Data({ ...newData});
		navigate('/Organization_Profile_P',{replace:true});
	}
	if(location.hash=="#Delete"){
		var Temp_Data2 =  JSON.parse(JSON.stringify(ORGANIZATION_PROFILE));
		if(Temp_Data2.status!="New"){
			handleDeleteORGANIZATION_PROFILE(Temp_Data2);
			navigate('/Organization_Profile#New',{replace:true});
		} 
		else 
			navigate('/Organization_Profile',{replace:true});
	}
	if(location.hash=="#Export"){
		setNewData({ ...newData});
		setApp_Data({ ...newData});
		navigate('/Organization_Profile',{replace:true});
	}
	if(location.hash=="#Import"){
		setNewData({ ...newData});
		setApp_Data({ ...newData});
		navigate('/Organization_Profile',{replace:true});
	}
	if(location.hash=="#Help"){
		setNewData({ ...newData});
		setApp_Data({ ...newData});
		navigate('/Organization_Profile',{replace:true});
	}
	if(location.hash=="#LogInLogOut"){
		setNewData({ ...newData});
		setApp_Data({ ...newData});
		navigate('/Organization_Profile',{replace:true});
	}


  }, [location.hash]);   // Use cleanup for location.hash such as }, [location.hash]);



  useEffect(() => {
	  
	    if (!ORGANIZATION_PROFILE) return;

    if (!initRef.current.headerHandled) {
	  for (let i = 1; i <= 10; i++) {
	  const sectionId = `#PLATFORM_CORE_02_ORGANIZATION_STAKEHOLDER_ONBOARDING_ORGANIZATION_PROFILE_${i}_SECTION`;
	  const headerId = `#PLATFORM_CORE_02_ORGANIZATION_STAKEHOLDER_ONBOARDING_ORGANIZATION_PROFILE_${i}_HEADER`;

	  if ($(sectionId).length && $(headerId).length) {
		
		const hiddenSections = [0];
		if (hiddenSections.includes(i)) {
		  $(sectionId).hide();
		} else {
		  $(sectionId).show();
		}

		$(headerId).off("click").on("click", function () {
		  $(sectionId).slideToggle();

		  const icon = $(this).find(".toggle-icon");
		  const current = icon.text().trim();

		  if (current === "v") {
			icon.text("^");
		  } else {
			icon.text("v");
		  }
		});
	  }
	}
      initRef.current.headerHandled = true;
  }


  if (!initRef.current.dataTableHandled) {

    initRef.current.dataTableHandled = true;
  }  

  }, [ORGANIZATION_PROFILE]) ;


  
  
  var Ids = [];
  for(var Ele in ORGANIZATION_PROFILE){
	  for(var Sec in ORGANIZATION_PROFILE[Ele]){
		if(Sec == "id")
			Ids.push(ORGANIZATION_PROFILE[Ele]["id"]);
		else if(Sec == "status")
			Ids.push(ORGANIZATION_PROFILE[Ele]["status"]);
		else if(Array.isArray(ORGANIZATION_PROFILE[Ele][Sec]))
			  for(var Row in ORGANIZATION_PROFILE[Ele][Sec])  // Convert to ORGANIZATION_PROFILE[Ele][Sec].forEach((row) => { ... })
				for (var Id in Row) 
					Ids.push(Id);
		else
			for (var Id in ORGANIZATION_PROFILE[Ele][Sec]) 
				Ids.push(Id);
	  }
  }
  const [isValid, setIsValid] = useState(Object.fromEntries(Ids.map(key => [key, true])));
   
   
  React.useEffect(() => {
	if (didFetchRef.current) return;
    didFetchRef.current = true;

	var Temp_Data= JSON.parse(JSON.stringify(App_Data));
	Temp_Data["ORGANIZATION_PROFILE"] = 0;
	setApp_Data({...Temp_Data})

	const collectClientInfo = () => {
	  return {
		userAgent: navigator.userAgent,
		language: navigator.language,
		platform: navigator.platform,
		screenResolution: `${screen.width}x${screen.height}`,
		colorDepth: screen.colorDepth,
		timezoneOffset: new Date().getTimezoneOffset(),
		timezone: Intl.DateTimeFormat().resolvedOptions().timeZone,
		cookieEnabled: navigator.cookieEnabled,
		javaEnabled: navigator.javaEnabled(),
		online: navigator.onLine,
		referrer: document.referrer,
		locationHref: window.location.href,
		screenOrientation: screen.orientation?.type || 'unknown',
	  };
	};
	const baseClientInfo = collectClientInfo();
	handleLoadNewORGANIZATION_PROFILE(baseClientInfo,"FirstLoad");
 
/*	axios.get(`https://stark-rwae-app-awc3egftahdtgwca.centralus-01.azurewebsites.net/ORGANIZATION_PROFILE`).then((response1) => {
		if(!ORGANIZATION_PROFILE) 
			setORGANIZATION_PROFILE(JSON.parse(JSON.stringify(response1.data)));
		axios.get(`https://stark-rwae-app-awc3egftahdtgwca.centralus-01.azurewebsites.net/ORGANIZATION_PROFILE_D`).then((response2) => {
			setORGANIZATION_PROFILE_D( JSON.parse(JSON.stringify(response2.data)));
			handleAddORGANIZATION_PROFILE_Load_Add_New(response1.data,response2.data);
		});
    });
*/

	//$('#navbarNav1').hide();
//$('#navbarNav6').hide();

  }, []);


 const handleLoadNewORGANIZATION_PROFILE = async (clientInfo, status) => {
	axios.post('https://stark-rwae-app-awc3egftahdtgwca.centralus-01.azurewebsites.net/ORGANIZATION_PROFILE/New', {clientInfo, clientStamp: Date.now(), status:status})
	  .then(response => {
		setORGANIZATION_PROFILE(response.data);
	  })
	  .catch(error => {
		console.error('Error sending client info:', error);
	  });
  };



   

 const handleLastDataORGANIZATION_PROFILE = async (data) => {
	const collectClientInfo = () => {
	return {
		userAgent: navigator.userAgent,
		language: navigator.language,
		platform: navigator.platform,
		screenResolution: `${screen.width}x${screen.height}`,
		colorDepth: screen.colorDepth,
		timezoneOffset: new Date().getTimezoneOffset(),
		timezone: Intl.DateTimeFormat().resolvedOptions().timeZone,
		cookieEnabled: navigator.cookieEnabled,
		javaEnabled: navigator.javaEnabled(),
		online: navigator.onLine,
		referrer: document.referrer,
		locationHref: window.location.href,
		screenOrientation: screen.orientation?.type || 'unknown'
	  };
	};
	
	const clientInfo = collectClientInfo();

    fetch('https://stark-rwae-app-awc3egftahdtgwca.centralus-01.azurewebsites.net/ORGANIZATION_PROFILE/Status', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ data: data, clientInfo:clientInfo , stamp: Date.now() })
    }).catch(err => {
      console.error("Error", err);
    });
  };


  const handlePutORGANIZATION_PROFILE = async (Updated) => {
    try {
		axios.put('https://stark-rwae-app-awc3egftahdtgwca.centralus-01.azurewebsites.net/ORGANIZATION_PROFILE/', Updated);
    } catch (error) {
      console.error('Error updating put:', error);
    }
  };
  
  
  
  
  const handlePostORGANIZATION_PROFILE = async (Updated) => {
    try {
		axios.post('https://stark-rwae-app-awc3egftahdtgwca.centralus-01.azurewebsites.net/ORGANIZATION_PROFILE', Updated);
    } catch (error) {
      console.error('Error adding post:', error);
    }
  };
 
   
 

  const handleDeleteORGANIZATION_PROFILE = async (Updated) => {
    try {
		console.log(JSON.stringify(Updated));
		axios.delete('https://stark-rwae-app-awc3egftahdtgwca.centralus-01.azurewebsites.net/ORGANIZATION_PROFILE', {
            data: Updated,
            headers: {
                'Content-Type': 'application/json' 
			    }
            });
    } catch (error) {
      console.error('Error updating put:', error);
    }
  };
  
  
  
     
const PLATFORM_CORE_02_ORGANIZATION_STAKEHOLDER_ONBOARDING_ORGANIZATION_PROFILE_1_0_Change = (event) => {
    const value = event.target.value; //const { value } = event.target;
    const regex = /^[a-zA-Z\s]*$/; // Example regex: only allows alphabets and spaces
	var Temp_isValid = JSON.parse(JSON.stringify(isValid));
    Temp_isValid["PLATFORM_CORE_02_ORGANIZATION_STAKEHOLDER_ONBOARDING_ORGANIZATION_PROFILE_1_0"]  = regex.test(value);
    setIsValid(Temp_isValid);
	var Temp_Data = JSON.parse(JSON.stringify(ORGANIZATION_PROFILE));
	Temp_Data["1"]["PLATFORM_CORE_02_ORGANIZATION_STAKEHOLDER_ONBOARDING_ORGANIZATION_PROFILE_1_0"]=value;
	//handleAddORGANIZATION_PROFILE(Temp_Data,App_Data['ORGANIZATION_PROFILE']);
	Form_Data_onChange("1","PLATFORM_CORE_02_ORGANIZATION_STAKEHOLDER_ONBOARDING_ORGANIZATION_PROFILE_1_0",value,Temp_Data);
 	//handleLastDataORGANIZATION_PROFILE(Temp_Data);
    setORGANIZATION_PROFILE(Temp_Data);
 }; 
  

const PLATFORM_CORE_02_ORGANIZATION_STAKEHOLDER_ONBOARDING_ORGANIZATION_PROFILE_1_1_Change = (event) => {
    const value = event.target.value; //const { value } = event.target;
    const regex = /^[a-zA-Z\s]*$/; // Example regex: only allows alphabets and spaces
	var Temp_isValid = JSON.parse(JSON.stringify(isValid));
    Temp_isValid["PLATFORM_CORE_02_ORGANIZATION_STAKEHOLDER_ONBOARDING_ORGANIZATION_PROFILE_1_1"]  = regex.test(value);
    setIsValid(Temp_isValid);
	var Temp_Data = JSON.parse(JSON.stringify(ORGANIZATION_PROFILE));
	Temp_Data["1"]["PLATFORM_CORE_02_ORGANIZATION_STAKEHOLDER_ONBOARDING_ORGANIZATION_PROFILE_1_1"]=value;
	Form_Data_onChange("1","PLATFORM_CORE_02_ORGANIZATION_STAKEHOLDER_ONBOARDING_ORGANIZATION_PROFILE_1_1",value,Temp_Data);
 	//handleLastDataORGANIZATION_PROFILE(Temp_Data);
    setORGANIZATION_PROFILE(Temp_Data);
	//handleAddORGANIZATION_PROFILE(Temp_Data,App_Data['ORGANIZATION_PROFILE']);
  }; 
  

    
const PLATFORM_CORE_02_ORGANIZATION_STAKEHOLDER_ONBOARDING_ORGANIZATION_PROFILE_1_2_Change = (event) => {
    const value = event.target.value; //const { value } = event.target;
    const regex = /^[a-zA-Z\s]*$/; // Example regex: only allows alphabets and spaces
	var Temp_isValid = JSON.parse(JSON.stringify(isValid));
    Temp_isValid["PLATFORM_CORE_02_ORGANIZATION_STAKEHOLDER_ONBOARDING_ORGANIZATION_PROFILE_1_2"]  = regex.test(value);
    setIsValid(Temp_isValid);
	var Temp_Data = JSON.parse(JSON.stringify(ORGANIZATION_PROFILE));
	Temp_Data["1"]["PLATFORM_CORE_02_ORGANIZATION_STAKEHOLDER_ONBOARDING_ORGANIZATION_PROFILE_1_2"]=value;
	//handleAddORGANIZATION_PROFILE(Temp_Data,App_Data['ORGANIZATION_PROFILE']);
	Form_Data_onChange("1","PLATFORM_CORE_02_ORGANIZATION_STAKEHOLDER_ONBOARDING_ORGANIZATION_PROFILE_1_2",value,Temp_Data);
 	//handleLastDataORGANIZATION_PROFILE(Temp_Data);
    setORGANIZATION_PROFILE(Temp_Data);
 }; 
  
    
const PLATFORM_CORE_02_ORGANIZATION_STAKEHOLDER_ONBOARDING_ORGANIZATION_PROFILE_1_3_Change = (event) => {
    const value = event.target.value; //const { value } = event.target;
    const regex = /^[a-zA-Z\s]*$/; // Example regex: only allows alphabets and spaces
	var Temp_isValid = JSON.parse(JSON.stringify(isValid));
    Temp_isValid["PLATFORM_CORE_02_ORGANIZATION_STAKEHOLDER_ONBOARDING_ORGANIZATION_PROFILE_1_3"]  = regex.test(value);
    setIsValid(Temp_isValid);
	var Temp_Data = JSON.parse(JSON.stringify(ORGANIZATION_PROFILE));
	Temp_Data["1"]["PLATFORM_CORE_02_ORGANIZATION_STAKEHOLDER_ONBOARDING_ORGANIZATION_PROFILE_1_3"]=value;
	//handleAddORGANIZATION_PROFILE(Temp_Data,App_Data['ORGANIZATION_PROFILE']);
	Form_Data_onChange("1","PLATFORM_CORE_02_ORGANIZATION_STAKEHOLDER_ONBOARDING_ORGANIZATION_PROFILE_1_3",value,Temp_Data);
 	//handleLastDataORGANIZATION_PROFILE(Temp_Data);
    setORGANIZATION_PROFILE(Temp_Data);
 }; 
  
    
const PLATFORM_CORE_02_ORGANIZATION_STAKEHOLDER_ONBOARDING_ORGANIZATION_PROFILE_2_0_Change = (event) => {
    const value = event.target.value; //const { value } = event.target;
    const regex = /^[a-zA-Z\s]*$/; // Example regex: only allows alphabets and spaces
	var Temp_isValid = JSON.parse(JSON.stringify(isValid));
    Temp_isValid["PLATFORM_CORE_02_ORGANIZATION_STAKEHOLDER_ONBOARDING_ORGANIZATION_PROFILE_2_0"]  = regex.test(value);
    setIsValid(Temp_isValid);
	var Temp_Data = JSON.parse(JSON.stringify(ORGANIZATION_PROFILE));
	Temp_Data["2"]["PLATFORM_CORE_02_ORGANIZATION_STAKEHOLDER_ONBOARDING_ORGANIZATION_PROFILE_2_0"]=value;
	//handleAddORGANIZATION_PROFILE(Temp_Data,App_Data['ORGANIZATION_PROFILE']);
	Form_Data_onChange("2","PLATFORM_CORE_02_ORGANIZATION_STAKEHOLDER_ONBOARDING_ORGANIZATION_PROFILE_2_0",value,Temp_Data);
 	//handleLastDataORGANIZATION_PROFILE(Temp_Data);
    setORGANIZATION_PROFILE(Temp_Data);
 }; 
  

const PLATFORM_CORE_02_ORGANIZATION_STAKEHOLDER_ONBOARDING_ORGANIZATION_PROFILE_2_1_Change = (event) => {
    const value = event.target.value; //const { value } = event.target;
    const regex = /^[a-zA-Z\s]*$/; // Example regex: only allows alphabets and spaces
	var Temp_isValid = JSON.parse(JSON.stringify(isValid));
    Temp_isValid["PLATFORM_CORE_02_ORGANIZATION_STAKEHOLDER_ONBOARDING_ORGANIZATION_PROFILE_2_1"]  = regex.test(value);
    setIsValid(Temp_isValid);
	var Temp_Data = JSON.parse(JSON.stringify(ORGANIZATION_PROFILE));
	Temp_Data["2"]["PLATFORM_CORE_02_ORGANIZATION_STAKEHOLDER_ONBOARDING_ORGANIZATION_PROFILE_2_1"]=value;
	Form_Data_onChange("2","PLATFORM_CORE_02_ORGANIZATION_STAKEHOLDER_ONBOARDING_ORGANIZATION_PROFILE_2_1",value,Temp_Data);
 	//handleLastDataORGANIZATION_PROFILE(Temp_Data);
    setORGANIZATION_PROFILE(Temp_Data);
	//handleAddORGANIZATION_PROFILE(Temp_Data,App_Data['ORGANIZATION_PROFILE']);
  }; 
  

    
const PLATFORM_CORE_02_ORGANIZATION_STAKEHOLDER_ONBOARDING_ORGANIZATION_PROFILE_2_2_Change = (event) => {
    const value = event.target.value; //const { value } = event.target;
    const regex = /^[a-zA-Z\s]*$/; // Example regex: only allows alphabets and spaces
	var Temp_isValid = JSON.parse(JSON.stringify(isValid));
    Temp_isValid["PLATFORM_CORE_02_ORGANIZATION_STAKEHOLDER_ONBOARDING_ORGANIZATION_PROFILE_2_2"]  = regex.test(value);
    setIsValid(Temp_isValid);
	var Temp_Data = JSON.parse(JSON.stringify(ORGANIZATION_PROFILE));
	Temp_Data["2"]["PLATFORM_CORE_02_ORGANIZATION_STAKEHOLDER_ONBOARDING_ORGANIZATION_PROFILE_2_2"]=value;
	//handleAddORGANIZATION_PROFILE(Temp_Data,App_Data['ORGANIZATION_PROFILE']);
	Form_Data_onChange("2","PLATFORM_CORE_02_ORGANIZATION_STAKEHOLDER_ONBOARDING_ORGANIZATION_PROFILE_2_2",value,Temp_Data);
 	//handleLastDataORGANIZATION_PROFILE(Temp_Data);
    setORGANIZATION_PROFILE(Temp_Data);
 }; 
  
    
const PLATFORM_CORE_02_ORGANIZATION_STAKEHOLDER_ONBOARDING_ORGANIZATION_PROFILE_3_0_Change = (event) => {
    const value = event.target.value; //const { value } = event.target;
    const regex = /^[a-zA-Z\s]*$/; // Example regex: only allows alphabets and spaces
	var Temp_isValid = JSON.parse(JSON.stringify(isValid));
    Temp_isValid["PLATFORM_CORE_02_ORGANIZATION_STAKEHOLDER_ONBOARDING_ORGANIZATION_PROFILE_3_0"]  = regex.test(value);
    setIsValid(Temp_isValid);
	var Temp_Data = JSON.parse(JSON.stringify(ORGANIZATION_PROFILE));
	Temp_Data["3"]["PLATFORM_CORE_02_ORGANIZATION_STAKEHOLDER_ONBOARDING_ORGANIZATION_PROFILE_3_0"]=value;
	//handleAddORGANIZATION_PROFILE(Temp_Data,App_Data['ORGANIZATION_PROFILE']);
	Form_Data_onChange("3","PLATFORM_CORE_02_ORGANIZATION_STAKEHOLDER_ONBOARDING_ORGANIZATION_PROFILE_3_0",value,Temp_Data);
 	//handleLastDataORGANIZATION_PROFILE(Temp_Data);
    setORGANIZATION_PROFILE(Temp_Data);
 }; 
  
    
const PLATFORM_CORE_02_ORGANIZATION_STAKEHOLDER_ONBOARDING_ORGANIZATION_PROFILE_3_1_Change = (event) => {
    const value = event.target.value; //const { value } = event.target;
    const regex = /^[a-zA-Z\s]*$/; // Example regex: only allows alphabets and spaces
	var Temp_isValid = JSON.parse(JSON.stringify(isValid));
    Temp_isValid["PLATFORM_CORE_02_ORGANIZATION_STAKEHOLDER_ONBOARDING_ORGANIZATION_PROFILE_3_1"]  = regex.test(value);
    setIsValid(Temp_isValid);
	var Temp_Data = JSON.parse(JSON.stringify(ORGANIZATION_PROFILE));
	Temp_Data["3"]["PLATFORM_CORE_02_ORGANIZATION_STAKEHOLDER_ONBOARDING_ORGANIZATION_PROFILE_3_1"]=value;
	//handleAddORGANIZATION_PROFILE(Temp_Data,App_Data['ORGANIZATION_PROFILE']);
	Form_Data_onChange("3","PLATFORM_CORE_02_ORGANIZATION_STAKEHOLDER_ONBOARDING_ORGANIZATION_PROFILE_3_1",value,Temp_Data);
 	//handleLastDataORGANIZATION_PROFILE(Temp_Data);
    setORGANIZATION_PROFILE(Temp_Data);
 }; 
  

const PLATFORM_CORE_02_ORGANIZATION_STAKEHOLDER_ONBOARDING_ORGANIZATION_PROFILE_4_0_Change = (event) => {
    const value = event.target.value; //const { value } = event.target;
    const regex = /^[a-zA-Z\s]*$/; // Example regex: only allows alphabets and spaces
	var Temp_isValid = JSON.parse(JSON.stringify(isValid));
    Temp_isValid["PLATFORM_CORE_02_ORGANIZATION_STAKEHOLDER_ONBOARDING_ORGANIZATION_PROFILE_4_0"]  = regex.test(value);
    setIsValid(Temp_isValid);
	var Temp_Data = JSON.parse(JSON.stringify(ORGANIZATION_PROFILE));
	Temp_Data["4"]["PLATFORM_CORE_02_ORGANIZATION_STAKEHOLDER_ONBOARDING_ORGANIZATION_PROFILE_4_0"]=value;
	Form_Data_onChange("4","PLATFORM_CORE_02_ORGANIZATION_STAKEHOLDER_ONBOARDING_ORGANIZATION_PROFILE_4_0",value,Temp_Data);
 	//handleLastDataORGANIZATION_PROFILE(Temp_Data);
    setORGANIZATION_PROFILE(Temp_Data);
	//handleAddORGANIZATION_PROFILE(Temp_Data,App_Data['ORGANIZATION_PROFILE']);
  }; 
  


const PLATFORM_CORE_02_ORGANIZATION_STAKEHOLDER_ONBOARDING_ORGANIZATION_PROFILE_9_0_Change = (event) => {
    const value = event.target.value; //const { value } = event.target;
    const regex = /^[a-zA-Z\s]*$/; // Example regex: only allows alphabets and spaces
	var Temp_isValid = JSON.parse(JSON.stringify(isValid));
    Temp_isValid["PLATFORM_CORE_02_ORGANIZATION_STAKEHOLDER_ONBOARDING_ORGANIZATION_PROFILE_9_0"]  = regex.test(value);
    setIsValid(Temp_isValid);
	var Temp_Data = JSON.parse(JSON.stringify(ORGANIZATION_PROFILE));
	Temp_Data["9"]["PLATFORM_CORE_02_ORGANIZATION_STAKEHOLDER_ONBOARDING_ORGANIZATION_PROFILE_9_0"]=value;
	Form_Data_onChange("9","PLATFORM_CORE_02_ORGANIZATION_STAKEHOLDER_ONBOARDING_ORGANIZATION_PROFILE_9_0",value,Temp_Data);
 	//handleLastDataORGANIZATION_PROFILE(Temp_Data);
    setORGANIZATION_PROFILE(Temp_Data);
	//handleAddORGANIZATION_PROFILE(Temp_Data,App_Data['ORGANIZATION_PROFILE']);
  }; 
  

    
const PLATFORM_CORE_02_ORGANIZATION_STAKEHOLDER_ONBOARDING_ORGANIZATION_PROFILE_9_1_Change = (event) => {
    const value = event.target.value; //const { value } = event.target;
    const regex = /^[a-zA-Z\s]*$/; // Example regex: only allows alphabets and spaces
	var Temp_isValid = JSON.parse(JSON.stringify(isValid));
    Temp_isValid["PLATFORM_CORE_02_ORGANIZATION_STAKEHOLDER_ONBOARDING_ORGANIZATION_PROFILE_9_1"]  = regex.test(value);
    setIsValid(Temp_isValid);
	var Temp_Data = JSON.parse(JSON.stringify(ORGANIZATION_PROFILE));
	Temp_Data["9"]["PLATFORM_CORE_02_ORGANIZATION_STAKEHOLDER_ONBOARDING_ORGANIZATION_PROFILE_9_1"]=value;
	//handleAddORGANIZATION_PROFILE(Temp_Data,App_Data['ORGANIZATION_PROFILE']);
	Form_Data_onChange("9","PLATFORM_CORE_02_ORGANIZATION_STAKEHOLDER_ONBOARDING_ORGANIZATION_PROFILE_9_1",value,Temp_Data);
 	//handleLastDataORGANIZATION_PROFILE(Temp_Data);
    setORGANIZATION_PROFILE(Temp_Data);
 }; 
  
    
const PLATFORM_CORE_02_ORGANIZATION_STAKEHOLDER_ONBOARDING_ORGANIZATION_PROFILE_9_2_Change = (event) => {
    const value = event.target.value; //const { value } = event.target;
    const regex = /^[a-zA-Z\s]*$/; // Example regex: only allows alphabets and spaces
	var Temp_isValid = JSON.parse(JSON.stringify(isValid));
    Temp_isValid["PLATFORM_CORE_02_ORGANIZATION_STAKEHOLDER_ONBOARDING_ORGANIZATION_PROFILE_9_2"]  = regex.test(value);
    setIsValid(Temp_isValid);
	var Temp_Data = JSON.parse(JSON.stringify(ORGANIZATION_PROFILE));
	Temp_Data["9"]["PLATFORM_CORE_02_ORGANIZATION_STAKEHOLDER_ONBOARDING_ORGANIZATION_PROFILE_9_2"]=value;
	//handleAddORGANIZATION_PROFILE(Temp_Data,App_Data['ORGANIZATION_PROFILE']);
	Form_Data_onChange("9","PLATFORM_CORE_02_ORGANIZATION_STAKEHOLDER_ONBOARDING_ORGANIZATION_PROFILE_9_2",value,Temp_Data);
 	//handleLastDataORGANIZATION_PROFILE(Temp_Data);
    setORGANIZATION_PROFILE(Temp_Data);
 }; 
  
    
const PLATFORM_CORE_02_ORGANIZATION_STAKEHOLDER_ONBOARDING_ORGANIZATION_PROFILE_9_3_Change = (event) => {
    const value = event.target.value; //const { value } = event.target;
    const regex = /^[a-zA-Z\s]*$/; // Example regex: only allows alphabets and spaces
	var Temp_isValid = JSON.parse(JSON.stringify(isValid));
    Temp_isValid["PLATFORM_CORE_02_ORGANIZATION_STAKEHOLDER_ONBOARDING_ORGANIZATION_PROFILE_9_3"]  = regex.test(value);
    setIsValid(Temp_isValid);
	var Temp_Data = JSON.parse(JSON.stringify(ORGANIZATION_PROFILE));
	Temp_Data["9"]["PLATFORM_CORE_02_ORGANIZATION_STAKEHOLDER_ONBOARDING_ORGANIZATION_PROFILE_9_3"]=value;
	//handleAddORGANIZATION_PROFILE(Temp_Data,App_Data['ORGANIZATION_PROFILE']);
	Form_Data_onChange("9","PLATFORM_CORE_02_ORGANIZATION_STAKEHOLDER_ONBOARDING_ORGANIZATION_PROFILE_9_3",value,Temp_Data);
 	//handleLastDataORGANIZATION_PROFILE(Temp_Data);
    setORGANIZATION_PROFILE(Temp_Data);
 }; 
  
    
const PLATFORM_CORE_02_ORGANIZATION_STAKEHOLDER_ONBOARDING_ORGANIZATION_PROFILE_9_4_Change = (event) => {
    const value = event.target.value; //const { value } = event.target;
    const regex = /^[a-zA-Z\s]*$/; // Example regex: only allows alphabets and spaces
	var Temp_isValid = JSON.parse(JSON.stringify(isValid));
    Temp_isValid["PLATFORM_CORE_02_ORGANIZATION_STAKEHOLDER_ONBOARDING_ORGANIZATION_PROFILE_9_4"]  = regex.test(value);
    setIsValid(Temp_isValid);
	var Temp_Data = JSON.parse(JSON.stringify(ORGANIZATION_PROFILE));
	Temp_Data["9"]["PLATFORM_CORE_02_ORGANIZATION_STAKEHOLDER_ONBOARDING_ORGANIZATION_PROFILE_9_4"]=value;
	//handleAddORGANIZATION_PROFILE(Temp_Data,App_Data['ORGANIZATION_PROFILE']);
	Form_Data_onChange("9","PLATFORM_CORE_02_ORGANIZATION_STAKEHOLDER_ONBOARDING_ORGANIZATION_PROFILE_9_4",value,Temp_Data);
 	//handleLastDataORGANIZATION_PROFILE(Temp_Data);
    setORGANIZATION_PROFILE(Temp_Data);
 }; 
  


 
const Form_Data_onChange = (Sec,ID,Value,Temp_Data) => {

};

  if (!ORGANIZATION_PROFILE) return <div>Loading...</div>;;

   const handleSingleClick = (event,ID) => {
	$(event.currentTarget).siblings().removeClass('selected');
    event.currentTarget.classList.toggle('selected');
   };


   const handleDoubleClick = (event,ID) => {
    const selectedRowId = event.currentTarget.id.replace("TR","");
    //newData.Return_Data=selectedRowId;
	setNewData({ ...newData});
	setApp_Data(newData)
    window.location.hash = 'Return';
   };

const handleAddRow = (Sec) => {
  const newRow = {};
  switch(Sec) {

  }


  const updatedORGANIZATION_PROFILE =JSON.parse(JSON.stringify(ORGANIZATION_PROFILE));
  updatedORGANIZATION_PROFILE[Sec] = [...updatedORGANIZATION_PROFILE[Sec], newRow];
  setORGANIZATION_PROFILE(updatedORGANIZATION_PROFILE);
};

const handleDeleteRow = (sec,index) => {
  const updatedORGANIZATION_PROFILE = JSON.parse(JSON.stringify(ORGANIZATION_PROFILE));
  updatedORGANIZATION_PROFILE[sec].splice(index, 1);
  setORGANIZATION_PROFILE(updatedORGANIZATION_PROFILE);
}; 

 const print_Canvas = async (ID) => {
const canvas = document.getElementById(ID);
const imgData = canvas.toDataURL("image/png");

const printWindow = window.open('', '_blank');
printWindow.document.write(`
  <html>
    <head><title>Print</title></head>
    <body style="margin:0">
      <img src="${imgData}" style="width:100%;"/>
      <script>
        window.onload = function() {
          window.print();
          window.onafterprint = function() {
            window.close();
          };
        };
      </script>
    </body>
  </html>
`);
printWindow.document.close();
}
  return <>
			<nav className="navbar navbar-expand-lg navbar-light bg-light">
			 <div style={{ padding: '10px 20px', fontSize: '1.5rem', fontWeight: 'bold' }}>
  {t(`Organization Profile`)}
  <hr style={{ marginTop: '8px', borderTop: '2px solid #007bff', width: '100%' }} />
</div>
			 <button className="navbar-toggler" type="button" data-toggle="collapse" data-target="#navbarNav"
				aria-controls="navbarNav" aria-expanded="false" aria-label="Toggle navigation">
			 <span className="navbar-toggler-icon"></span>
			 </button>
			 <div className="collapse navbar-collapse" id="navbarNav">
				<ul className="navbar-nav">
				   <li className="nav-item active">
					  <a  id="navbarNav2" className="nav-link" href="#New">{t(`New`)}</a>
				   </li>
				   <li className="nav-item">
					  <a  id="navbarNav3" className="nav-link" href="#Search">{t(`Search`)}</a>
				   </li>
				   <li className="nav-item">
					  <a  id="navbarNav4" className="nav-link" href="#Update">{t(`Update`)}</a>
				   </li>
				   <li className="nav-item">
					  <a  id="navbarNav8" className="nav-link" href="#Delete">{t(`Delete`)}</a>
				   </li>
				</ul>
			 </div>
		  </nav>	
         {/* Section Section.Number Section.Title Section.Detail*/}
         <div className="container-fluid mt-5">
            <h2 id="PLATFORM_CORE_02_ORGANIZATION_STAKEHOLDER_ONBOARDING_ORGANIZATION_PROFILE_1_HEADER" style={{ textAlign: ['fa', 'ar'].includes(i18n.language) ? 'right' : 'left' }}>{t(`Organization ID`)} <span className="toggle-icon">^</span></h2>
            <div id="PLATFORM_CORE_02_ORGANIZATION_STAKEHOLDER_ONBOARDING_ORGANIZATION_PROFILE_1_SECTION" className="row">
			                 {/* Text Box */}
               <div className="Data_Entry_Block  compact-view" style={{ width: '40ch' }}>
                  <div className="card mb-3" style={{ border: 'none'}}>
                     <div className="card-header" >
						 {t(`Organization ID`)}
                     </div>
                     <div className="card-body" style={{ width: '100%' }}>
                        <input id="PLATFORM_CORE_02_ORGANIZATION_STAKEHOLDER_ONBOARDING_ORGANIZATION_PROFILE_1_0" type="text" className="form-control" placeholder="Organization ID" value={ORGANIZATION_PROFILE["1"][`PLATFORM_CORE_02_ORGANIZATION_STAKEHOLDER_ONBOARDING_ORGANIZATION_PROFILE_1_0`]} 
						onChange={PLATFORM_CORE_02_ORGANIZATION_STAKEHOLDER_ONBOARDING_ORGANIZATION_PROFILE_1_0_Change} style={{ ...inputFontStyle, borderColor: isValid["PLATFORM_CORE_02_ORGANIZATION_STAKEHOLDER_ONBOARDING_ORGANIZATION_PROFILE_1_0"] ? 'blue' : 'red' }} />
                     </div>
                     <div className="card-footer" style={{ width: '40ch' }}>
						 {t(`Enter Organization ID`)}
                     </div>
                  </div>
               </div>
              {/* Simple Drop-down */}
               <div className="Data_Entry_Block compact-view" >
                  <div className="card mb-3" style={{ border: 'none'}}>
					 <div className="card-header" >
						{t(`Organization Type`)}
					 </div>
                     <div className="card-body" >
                        <select id="PLATFORM_CORE_02_ORGANIZATION_STAKEHOLDER_ONBOARDING_ORGANIZATION_PROFILE_1_1"  value={ORGANIZATION_PROFILE["1"][`PLATFORM_CORE_02_ORGANIZATION_STAKEHOLDER_ONBOARDING_ORGANIZATION_PROFILE_1_1`]} onChange={PLATFORM_CORE_02_ORGANIZATION_STAKEHOLDER_ONBOARDING_ORGANIZATION_PROFILE_1_1_Change} className="form-control" name="Organization Type"  >
						  <option value="LLC">LLC</option>
						  <option value="Corporation">Corporation</option>
						  <option value="Partnership">Partnership</option>
						  <option value="Trust">Trust</option>
						  <option value="Individual / Sole Proprietor">Individual / Sole Proprietor</option>
						  <option value="Government Entity">Government Entity</option>
						  <option value="Nonprofit">Nonprofit</option>
						  <option value="Other">Other</option>

						</select>
                     </div>
				     <div className="card-footer" >
					    Enter Organization Type
				     </div>
                  </div>
               </div>
               {/* Text Box */}
               <div className="Data_Entry_Block  compact-view" style={{ width: '180ch' }}>
                  <div className="card mb-3" style={{ border: 'none'}}>
                     <div className="card-header" >
						 {t(`Legal Name`)}
                     </div>
                     <div className="card-body" style={{ width: '100%' }}>
                        <input id="PLATFORM_CORE_02_ORGANIZATION_STAKEHOLDER_ONBOARDING_ORGANIZATION_PROFILE_1_2" type="text" className="form-control" placeholder="Legal Name" value={ORGANIZATION_PROFILE["1"][`PLATFORM_CORE_02_ORGANIZATION_STAKEHOLDER_ONBOARDING_ORGANIZATION_PROFILE_1_2`]} 
						onChange={PLATFORM_CORE_02_ORGANIZATION_STAKEHOLDER_ONBOARDING_ORGANIZATION_PROFILE_1_2_Change} style={{ ...inputFontStyle, borderColor: isValid["PLATFORM_CORE_02_ORGANIZATION_STAKEHOLDER_ONBOARDING_ORGANIZATION_PROFILE_1_2"] ? 'blue' : 'red' }} />
                     </div>
                     <div className="card-footer" style={{ width: '180ch' }}>
						 {t(`Enter Legal Name`)}
                     </div>
                  </div>
               </div>
               {/* Text Box */}
               <div className="Data_Entry_Block  compact-view" style={{ width: '160ch' }}>
                  <div className="card mb-3" style={{ border: 'none'}}>
                     <div className="card-header" >
						 {t(`DBA Name`)}
                     </div>
                     <div className="card-body" style={{ width: '100%' }}>
                        <input id="PLATFORM_CORE_02_ORGANIZATION_STAKEHOLDER_ONBOARDING_ORGANIZATION_PROFILE_1_3" type="text" className="form-control" placeholder="DBA Name" value={ORGANIZATION_PROFILE["1"][`PLATFORM_CORE_02_ORGANIZATION_STAKEHOLDER_ONBOARDING_ORGANIZATION_PROFILE_1_3`]} 
						onChange={PLATFORM_CORE_02_ORGANIZATION_STAKEHOLDER_ONBOARDING_ORGANIZATION_PROFILE_1_3_Change} style={{ ...inputFontStyle, borderColor: isValid["PLATFORM_CORE_02_ORGANIZATION_STAKEHOLDER_ONBOARDING_ORGANIZATION_PROFILE_1_3"] ? 'blue' : 'red' }} />
                     </div>
                     <div className="card-footer" style={{ width: '160ch' }}>
						 {t(`Enter DBA Name`)}
                     </div>
                  </div>
               </div>
							   
            </div>
         </div>
         {/* Section Section.Number Section.Title Section.Detail*/}
         <div className="container-fluid mt-5">
            <h2 id="PLATFORM_CORE_02_ORGANIZATION_STAKEHOLDER_ONBOARDING_ORGANIZATION_PROFILE_2_HEADER" style={{ textAlign: ['fa', 'ar'].includes(i18n.language) ? 'right' : 'left' }}>{t(`EIN Masked`)} <span className="toggle-icon">^</span></h2>
            <div id="PLATFORM_CORE_02_ORGANIZATION_STAKEHOLDER_ONBOARDING_ORGANIZATION_PROFILE_2_SECTION" className="row">
			                 {/* Text Box */}
               <div className="Data_Entry_Block  compact-view" style={{ width: '20ch' }}>
                  <div className="card mb-3" style={{ border: 'none'}}>
                     <div className="card-header" >
						 {t(`EIN Masked`)}
                     </div>
                     <div className="card-body" style={{ width: '100%' }}>
                        <input id="PLATFORM_CORE_02_ORGANIZATION_STAKEHOLDER_ONBOARDING_ORGANIZATION_PROFILE_2_0" type="text" className="form-control" placeholder="EIN Masked" value={ORGANIZATION_PROFILE["2"][`PLATFORM_CORE_02_ORGANIZATION_STAKEHOLDER_ONBOARDING_ORGANIZATION_PROFILE_2_0`]} 
						onChange={PLATFORM_CORE_02_ORGANIZATION_STAKEHOLDER_ONBOARDING_ORGANIZATION_PROFILE_2_0_Change} style={{ ...inputFontStyle, borderColor: isValid["PLATFORM_CORE_02_ORGANIZATION_STAKEHOLDER_ONBOARDING_ORGANIZATION_PROFILE_2_0"] ? 'blue' : 'red' }} />
                     </div>
                     <div className="card-footer" style={{ width: '20ch' }}>
						 {t(`Enter EIN Masked`)}
                     </div>
                  </div>
               </div>
              {/* Simple Drop-down */}
               <div className="Data_Entry_Block compact-view" >
                  <div className="card mb-3" style={{ border: 'none'}}>
					 <div className="card-header" >
						{t(`Formation State`)}
					 </div>
                     <div className="card-body" >
                        <select id="PLATFORM_CORE_02_ORGANIZATION_STAKEHOLDER_ONBOARDING_ORGANIZATION_PROFILE_2_1"  value={ORGANIZATION_PROFILE["2"][`PLATFORM_CORE_02_ORGANIZATION_STAKEHOLDER_ONBOARDING_ORGANIZATION_PROFILE_2_1`]} onChange={PLATFORM_CORE_02_ORGANIZATION_STAKEHOLDER_ONBOARDING_ORGANIZATION_PROFILE_2_1_Change} className="form-control" name="Formation State"  >
						  <option value="AL">AL</option>
						  <option value="AK">AK</option>
						  <option value="AZ">AZ</option>
						  <option value="AR">AR</option>
						  <option value="CA">CA</option>
						  <option value="CO">CO</option>
						  <option value="CT">CT</option>
						  <option value="DE">DE</option>
						  <option value="FL">FL</option>
						  <option value="GA">GA</option>
						  <option value="HI">HI</option>
						  <option value="ID">ID</option>
						  <option value="IL">IL</option>
						  <option value="IN">IN</option>
						  <option value="IA">IA</option>
						  <option value="KS">KS</option>
						  <option value="KY">KY</option>
						  <option value="LA">LA</option>
						  <option value="ME">ME</option>
						  <option value="MD">MD</option>
						  <option value="MA">MA</option>
						  <option value="MI">MI</option>
						  <option value="MN">MN</option>
						  <option value="MS">MS</option>
						  <option value="MO">MO</option>
						  <option value="MT">MT</option>
						  <option value="NE">NE</option>
						  <option value="NV">NV</option>
						  <option value="NH">NH</option>
						  <option value="NJ">NJ</option>
						  <option value="NM">NM</option>
						  <option value="NY">NY</option>
						  <option value="NC">NC</option>
						  <option value="ND">ND</option>
						  <option value="OH">OH</option>
						  <option value="OK">OK</option>
						  <option value="OR">OR</option>
						  <option value="PA">PA</option>
						  <option value="RI">RI</option>
						  <option value="SC">SC</option>
						  <option value="SD">SD</option>
						  <option value="TN">TN</option>
						  <option value="TX">TX</option>
						  <option value="UT">UT</option>
						  <option value="VT">VT</option>
						  <option value="VA">VA</option>
						  <option value="WA">WA</option>
						  <option value="WV">WV</option>
						  <option value="WI">WI</option>
						  <option value="WY">WY</option>
						  <option value="DC">DC</option>

						</select>
                     </div>
				     <div className="card-footer" >
					    Enter Formation State
				     </div>
                  </div>
               </div>
               {/* Text Box */}
               <div className="Data_Entry_Block  compact-view" style={{ width: '255ch' }}>
                  <div className="card mb-3" style={{ border: 'none'}}>
                     <div className="card-header" >
						 {t(`Website`)}
                     </div>
                     <div className="card-body" style={{ width: '100%' }}>
                        <input id="PLATFORM_CORE_02_ORGANIZATION_STAKEHOLDER_ONBOARDING_ORGANIZATION_PROFILE_2_2" type="text" className="form-control" placeholder="Website" value={ORGANIZATION_PROFILE["2"][`PLATFORM_CORE_02_ORGANIZATION_STAKEHOLDER_ONBOARDING_ORGANIZATION_PROFILE_2_2`]} 
						onChange={PLATFORM_CORE_02_ORGANIZATION_STAKEHOLDER_ONBOARDING_ORGANIZATION_PROFILE_2_2_Change} style={{ ...inputFontStyle, borderColor: isValid["PLATFORM_CORE_02_ORGANIZATION_STAKEHOLDER_ONBOARDING_ORGANIZATION_PROFILE_2_2"] ? 'blue' : 'red' }} />
                     </div>
                     <div className="card-footer" style={{ width: '255ch' }}>
						 {t(`Enter Website`)}
                     </div>
                  </div>
               </div>
							   
            </div>
         </div>
         {/* Section Section.Number Section.Title Section.Detail*/}
         <div className="container-fluid mt-5">
            <h2 id="PLATFORM_CORE_02_ORGANIZATION_STAKEHOLDER_ONBOARDING_ORGANIZATION_PROFILE_3_HEADER" style={{ textAlign: ['fa', 'ar'].includes(i18n.language) ? 'right' : 'left' }}>{t(`Primary Contact Name`)} <span className="toggle-icon">^</span></h2>
            <div id="PLATFORM_CORE_02_ORGANIZATION_STAKEHOLDER_ONBOARDING_ORGANIZATION_PROFILE_3_SECTION" className="row">
			                 {/* Text Box */}
               <div className="Data_Entry_Block  compact-view" style={{ width: '120ch' }}>
                  <div className="card mb-3" style={{ border: 'none'}}>
                     <div className="card-header" >
						 {t(`Primary Contact Name`)}
                     </div>
                     <div className="card-body" style={{ width: '100%' }}>
                        <input id="PLATFORM_CORE_02_ORGANIZATION_STAKEHOLDER_ONBOARDING_ORGANIZATION_PROFILE_3_0" type="text" className="form-control" placeholder="Primary Contact Name" value={ORGANIZATION_PROFILE["3"][`PLATFORM_CORE_02_ORGANIZATION_STAKEHOLDER_ONBOARDING_ORGANIZATION_PROFILE_3_0`]} 
						onChange={PLATFORM_CORE_02_ORGANIZATION_STAKEHOLDER_ONBOARDING_ORGANIZATION_PROFILE_3_0_Change} style={{ ...inputFontStyle, borderColor: isValid["PLATFORM_CORE_02_ORGANIZATION_STAKEHOLDER_ONBOARDING_ORGANIZATION_PROFILE_3_0"] ? 'blue' : 'red' }} />
                     </div>
                     <div className="card-footer" style={{ width: '120ch' }}>
						 {t(`Enter Primary Contact Name`)}
                     </div>
                  </div>
               </div>
               {/* Text Box */}
               <div className="Data_Entry_Block  compact-view" style={{ width: '160ch' }}>
                  <div className="card mb-3" style={{ border: 'none'}}>
                     <div className="card-header" >
						 {t(`Primary Contact Email`)}
                     </div>
                     <div className="card-body" style={{ width: '100%' }}>
                        <input id="PLATFORM_CORE_02_ORGANIZATION_STAKEHOLDER_ONBOARDING_ORGANIZATION_PROFILE_3_1" type="text" className="form-control" placeholder="Primary Contact Email" value={ORGANIZATION_PROFILE["3"][`PLATFORM_CORE_02_ORGANIZATION_STAKEHOLDER_ONBOARDING_ORGANIZATION_PROFILE_3_1`]} 
						onChange={PLATFORM_CORE_02_ORGANIZATION_STAKEHOLDER_ONBOARDING_ORGANIZATION_PROFILE_3_1_Change} style={{ ...inputFontStyle, borderColor: isValid["PLATFORM_CORE_02_ORGANIZATION_STAKEHOLDER_ONBOARDING_ORGANIZATION_PROFILE_3_1"] ? 'blue' : 'red' }} />
                     </div>
                     <div className="card-footer" style={{ width: '160ch' }}>
						 {t(`Enter Primary Contact Email`)}
                     </div>
                  </div>
               </div>
							   
            </div>
         </div>
         {/* Section Section.Number Section.Title Section.Detail*/}
         <div className="container-fluid mt-5">
            <h2 id="PLATFORM_CORE_02_ORGANIZATION_STAKEHOLDER_ONBOARDING_ORGANIZATION_PROFILE_4_HEADER" style={{ textAlign: ['fa', 'ar'].includes(i18n.language) ? 'right' : 'left' }}>{t(`Verification Status`)} <span className="toggle-icon">^</span></h2>
            <div id="PLATFORM_CORE_02_ORGANIZATION_STAKEHOLDER_ONBOARDING_ORGANIZATION_PROFILE_4_SECTION" className="row">
			                {/* Simple Drop-down */}
               <div className="Data_Entry_Block compact-view" >
                  <div className="card mb-3" style={{ border: 'none'}}>
					 <div className="card-header" >
						{t(`Verification Status`)}
					 </div>
                     <div className="card-body" >
                        <select id="PLATFORM_CORE_02_ORGANIZATION_STAKEHOLDER_ONBOARDING_ORGANIZATION_PROFILE_4_0"  value={ORGANIZATION_PROFILE["4"][`PLATFORM_CORE_02_ORGANIZATION_STAKEHOLDER_ONBOARDING_ORGANIZATION_PROFILE_4_0`]} onChange={PLATFORM_CORE_02_ORGANIZATION_STAKEHOLDER_ONBOARDING_ORGANIZATION_PROFILE_4_0_Change} className="form-control" name="Verification Status"  >
						  <option value="Not Started">Not Started</option>
						  <option value="Pending">Pending</option>
						  <option value="Verified">Verified</option>
						  <option value="Failed">Failed</option>
						  <option value="Expired">Expired</option>
						  <option value="Waived">Waived</option>

						</select>
                     </div>
				     <div className="card-footer" >
					    Enter Verification Status
				     </div>
                  </div>
               </div>
							   
            </div>
         </div>
         {/* Section Section.Number Section.Title Section.Detail*/}
         <div className="container-fluid mt-5">
            <h2 id="PLATFORM_CORE_02_ORGANIZATION_STAKEHOLDER_ONBOARDING_ORGANIZATION_PROFILE_9_HEADER" style={{ textAlign: ['fa', 'ar'].includes(i18n.language) ? 'right' : 'left' }}>{t(`Record Status`)} <span className="toggle-icon">^</span></h2>
            <div id="PLATFORM_CORE_02_ORGANIZATION_STAKEHOLDER_ONBOARDING_ORGANIZATION_PROFILE_9_SECTION" className="row">
			                {/* Simple Drop-down */}
               <div className="Data_Entry_Block compact-view" >
                  <div className="card mb-3" style={{ border: 'none'}}>
					 <div className="card-header" >
						{t(`Record Status`)}
					 </div>
                     <div className="card-body" >
                        <select id="PLATFORM_CORE_02_ORGANIZATION_STAKEHOLDER_ONBOARDING_ORGANIZATION_PROFILE_9_0"  value={ORGANIZATION_PROFILE["9"][`PLATFORM_CORE_02_ORGANIZATION_STAKEHOLDER_ONBOARDING_ORGANIZATION_PROFILE_9_0`]} onChange={PLATFORM_CORE_02_ORGANIZATION_STAKEHOLDER_ONBOARDING_ORGANIZATION_PROFILE_9_0_Change} className="form-control" name="Record Status"  >
						  <option value="Draft">Draft</option>
						  <option value="Active">Active</option>
						  <option value="Inactive">Inactive</option>
						  <option value="Archived">Archived</option>
						  <option value="Deleted">Deleted</option>

						</select>
                     </div>
				     <div className="card-footer" >
					    Enter Record Status
				     </div>
                  </div>
               </div>
               {/* Text Box */}
               <div className="Data_Entry_Block  compact-view" style={{ width: '40ch' }}>
                  <div className="card mb-3" style={{ border: 'none'}}>
                     <div className="card-header" >
						 {t(`Created By`)}
                     </div>
                     <div className="card-body" style={{ width: '100%' }}>
                        <input id="PLATFORM_CORE_02_ORGANIZATION_STAKEHOLDER_ONBOARDING_ORGANIZATION_PROFILE_9_1" type="text" className="form-control" placeholder="Created By" value={ORGANIZATION_PROFILE["9"][`PLATFORM_CORE_02_ORGANIZATION_STAKEHOLDER_ONBOARDING_ORGANIZATION_PROFILE_9_1`]} 
						onChange={PLATFORM_CORE_02_ORGANIZATION_STAKEHOLDER_ONBOARDING_ORGANIZATION_PROFILE_9_1_Change} style={{ ...inputFontStyle, borderColor: isValid["PLATFORM_CORE_02_ORGANIZATION_STAKEHOLDER_ONBOARDING_ORGANIZATION_PROFILE_9_1"] ? 'blue' : 'red' }} />
                     </div>
                     <div className="card-footer" style={{ width: '40ch' }}>
						 {t(`Enter Created By`)}
                     </div>
                  </div>
               </div>
               {/* Text Box */}
               <div className="Data_Entry_Block  compact-view" style={{ width: '30ch' }}>
                  <div className="card mb-3" style={{ border: 'none'}}>
                     <div className="card-header" >
						 {t(`Created At`)}
                     </div>
                     <div className="card-body" style={{ width: '100%' }}>
                        <input id="PLATFORM_CORE_02_ORGANIZATION_STAKEHOLDER_ONBOARDING_ORGANIZATION_PROFILE_9_2" type="text" className="form-control" placeholder="Created At" value={ORGANIZATION_PROFILE["9"][`PLATFORM_CORE_02_ORGANIZATION_STAKEHOLDER_ONBOARDING_ORGANIZATION_PROFILE_9_2`]} 
						onChange={PLATFORM_CORE_02_ORGANIZATION_STAKEHOLDER_ONBOARDING_ORGANIZATION_PROFILE_9_2_Change} style={{ ...inputFontStyle, borderColor: isValid["PLATFORM_CORE_02_ORGANIZATION_STAKEHOLDER_ONBOARDING_ORGANIZATION_PROFILE_9_2"] ? 'blue' : 'red' }} />
                     </div>
                     <div className="card-footer" style={{ width: '30ch' }}>
						 {t(`Enter Created At`)}
                     </div>
                  </div>
               </div>
               {/* Text Box */}
               <div className="Data_Entry_Block  compact-view" style={{ width: '40ch' }}>
                  <div className="card mb-3" style={{ border: 'none'}}>
                     <div className="card-header" >
						 {t(`Updated By`)}
                     </div>
                     <div className="card-body" style={{ width: '100%' }}>
                        <input id="PLATFORM_CORE_02_ORGANIZATION_STAKEHOLDER_ONBOARDING_ORGANIZATION_PROFILE_9_3" type="text" className="form-control" placeholder="Updated By" value={ORGANIZATION_PROFILE["9"][`PLATFORM_CORE_02_ORGANIZATION_STAKEHOLDER_ONBOARDING_ORGANIZATION_PROFILE_9_3`]} 
						onChange={PLATFORM_CORE_02_ORGANIZATION_STAKEHOLDER_ONBOARDING_ORGANIZATION_PROFILE_9_3_Change} style={{ ...inputFontStyle, borderColor: isValid["PLATFORM_CORE_02_ORGANIZATION_STAKEHOLDER_ONBOARDING_ORGANIZATION_PROFILE_9_3"] ? 'blue' : 'red' }} />
                     </div>
                     <div className="card-footer" style={{ width: '40ch' }}>
						 {t(`Enter Updated By`)}
                     </div>
                  </div>
               </div>
               {/* Text Box */}
               <div className="Data_Entry_Block  compact-view" style={{ width: '30ch' }}>
                  <div className="card mb-3" style={{ border: 'none'}}>
                     <div className="card-header" >
						 {t(`Updated At`)}
                     </div>
                     <div className="card-body" style={{ width: '100%' }}>
                        <input id="PLATFORM_CORE_02_ORGANIZATION_STAKEHOLDER_ONBOARDING_ORGANIZATION_PROFILE_9_4" type="text" className="form-control" placeholder="Updated At" value={ORGANIZATION_PROFILE["9"][`PLATFORM_CORE_02_ORGANIZATION_STAKEHOLDER_ONBOARDING_ORGANIZATION_PROFILE_9_4`]} 
						onChange={PLATFORM_CORE_02_ORGANIZATION_STAKEHOLDER_ONBOARDING_ORGANIZATION_PROFILE_9_4_Change} style={{ ...inputFontStyle, borderColor: isValid["PLATFORM_CORE_02_ORGANIZATION_STAKEHOLDER_ONBOARDING_ORGANIZATION_PROFILE_9_4"] ? 'blue' : 'red' }} />
                     </div>
                     <div className="card-footer" style={{ width: '30ch' }}>
						 {t(`Enter Updated At`)}
                     </div>
                  </div>
               </div>
							   
            </div>
         </div>

  </>;
};

export default Organization_Profile;  